import { useAppSelector } from "@/store"
import { selectConnStats } from "@/stores/conn_stats_slice"
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react"
import React, { useMemo } from "react"

export const StatisticContent: React.FC = () => {
  const connStats = useAppSelector(selectConnStats)
  const networkQualityLabel = {
    perfect: "蓝灯",
    good: "绿灯",
    normal: "黄灯",
    bad: "红灯",
  }[connStats.networkQuality.status]
  const networkQualityColor = {
    perfect: "#2196F3",
    good: "#4CAF50",
    normal: "#FFEB3B",
    bad: "#B71C1C",
  }[connStats.networkQuality.status]

  // 性能模块数据
  const propertyArr = useMemo(() => {
    return [
      {
        label: "延迟ms",
        value: connStats.rtt,
        valueColor: "#EE4C00",
        unit: "",
      },
      {
        label: "帧率fps",
        value: connStats.fps,
        valueColor: "#4EE2C5",
        unit: "",
      },
      {
        label: "丢包率",
        value: connStats.lostRate.toFixed(2),
        valueColor: "#FF9F3B",
        unit: "%",
      },
      {
        label: "码率Mbps",
        value: connStats.byteReceived.toFixed(2),
        valueColor: "#90919B",
        unit: "",
      },
      {
        label: "分辨率",
        value: connStats.resolution,
        valueColor: "#D8D8D8",
        unit: "",
        fullWidth: true,
      },
      {
        label: "网络质量",
        value: `${networkQualityLabel}, ${connStats.networkQuality.reason}`,
        valueColor: networkQualityColor,
        unit: "",
        fullWidth: true,
        valueFontSize: "16px",
        valueLineHeight: "25px",
      },
    ]
  }, [connStats])

  const buildItem = (item: any, i: number): React.ReactNode => {
    return (
      <GridItem
        key={`statistic-${i}`}
        display="flex"
        colSpan={item.fullWidth ? 2 : undefined}
        flexDirection="column"
        marginBottom="3px"
      >
        <Text color="#FFFFFF" marginBottom="2px" fontSize="15px">
          {item.label}
        </Text>
        <Flex>
          <Text
            color={item.valueColor}
            margin="0px"
            fontSize={item.valueFontSize ?? "20px"}
            fontWeight={item.valueFontWeight ?? 500}
            lineHeight={item.valueLineHeight}
          >
            <span>{item.value}</span>
            <span style={{ fontSize: 16 }}>{item.unit}</span>
          </Text>
        </Flex>
      </GridItem>
    )
  }

  return (
    <Grid
      templateColumns="repeat(2, 1fr)"
      columnGap={4}
      rowGap="18px"
      alignContent="start"
      padding="24px"
    >
      {propertyArr.map(buildItem)}
    </Grid>
  )
}
